import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link  } from "react-router-dom";
import Search from "../../components/Search/Search.js";

import './AppHeader.css';

class AppHeader extends React.Component {

  logo = false;
  show_sign_in = false;
  className = '';

  constructor(props) {
    super(props);

    this.logo = props.logo ? props.logo : 'logo_black.svg';
    this.className = props.className ? props.className : '';

    this.state = {
      signed: window.AppRef.current.get_is_signed()
    };
  }

  is_welcome_page() {
    return window.location.pathname === '/welcome' && !this.state.signed;
  }

  closeMenus() {
    window.modals.ProfileMenuRef.current.hide(); 
    window.modals.ProductsMenuRef.current.hide();
  }

  render() {
    const SearchRef = new React.createRef();

    return (
      <header className={this.className + ' ' + (this.is_welcome_page() ? 'welcome' : '')}>
        <Search ref={SearchRef} /> 

        <div className="logo">
          <Link to="/">
            <ReactSVG src={`assets/images/${this.logo}`} />
          </Link>
        </div>
        {/*{this.is_welcome_page() ? <div className="sign_in">
          <Link data-type="in_app" className="button" to="/sign_in">{i18n.t('welcomeSignIn')}</Link>
        </div> : ''}*/}
        {!this.is_welcome_page() ? <div className="icons"> 
          {window.location.pathname !== '/sign_in' && window.location.pathname !== '/account_create' ? 
            <div className="icon" onClick={() => SearchRef.current.toggle()}><ReactSVG src={`assets/images/search.svg`} /></div> 
            : ''}
          
          {this.state.signed ? 
            <div className="icon"><ReactSVG onClick={() => window.modals.MyMessagesRef.current.toggle()} src={`assets/images/notifications.svg`} />{window.AppRef.current.state.unread_messages ? <div className="counter">{window.AppRef.current.state.unread_messages}</div> : ''}</div> 
            : ''}
 
          {!this.state.signed && window.location.pathname !== '/sign_in' && window.location.pathname !== '/account_create' ? 
            <Link onClick={() => this.closeMenus()} data-type="in_app" className="icon" to="/welcome"><ReactSVG src={`assets/images/menu_profile.svg`} /></Link> 
            : ''}
        </div> : ''}

      </header>
    );
  }
};

export default AppHeader;

